import Fetcher from 'libs/fetcher';

const fetcher = new Fetcher();

export const getCurrentUser = async () => {
  const user = await fetcher.get({ path: '/users/current' });
  return user;
};

export const getUserByUid = async (uid) => fetcher.get({
  path: `/users/${uid}`,
});

export const createUser = async (data) => fetcher.post({
  path: '/users',
  body: data,
});

export const updateUser = async (userId, data) => fetcher.put({
  path: `/users/${userId}`,
  body: data,
});

export const getOrgUsers = async () => fetcher.get({
  path: '/users/organization',
});

export async function sendPasswordResetEmail(email) {
  // Import auth from Firebase
  const { auth } = await import('utils/firebase');
  return auth.sendPasswordResetEmail(email);
}
